import clsx from 'clsx';
import React from 'react';

const Select = ({ label, wrapperClassName, ...props }) => {
  return (
    <div className={clsx('select__wrapper', wrapperClassName)}>
      {label && (
        <label htmlFor={props.id} className="select__label">
          {label}
          {props.required && '*'}
        </label>
      )}
      <select className="select" {...props}></select>
    </div>
  );
};

export default Select;